module.exports = __webpack_public_path__ + "img/A_4AOU-58_3.db4c7e29.png";